import { useMemo } from "react";

import Image from "next/image";

import { ReassuranceBanner as UIReassuranceBanner } from "@jti/ui/components/ReassuranceBanner";

import type { ReassuranceBannerBuilderProps } from "./inputs.builder";

import styles from "./ReassuranceBanner.module.scss";

export function ReassuranceBanner(props: ReassuranceBannerBuilderProps) {
  const { title, items: _items, bottomText, backgroundImage, mobileBackgroundImage } = props;

  const items = useMemo(
    () =>
      _items.map((item) => ({
        ...item,
        id: item.title,
        icon: () => (
          <div className={styles.imageWrapper}>
            <Image src={item.icon} alt={item.title} fill={true} />
          </div>
        ),
      })),
    [_items]
  );

  return (
    <UIReassuranceBanner
      items={items}
      title={title || ""}
      bottomText={bottomText}
      backgroundImageUrl={backgroundImage}
      mobileBackgroundImageUrl={mobileBackgroundImage}
    />
  );
}
